@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.template-field {
  display: flex;
  font-size: 14px;
  line-height: 16px;
}

.template-attribute--required {
  color: var(--default--disabled--text-color--4);
  margin-left: @space-4;
}

.template-attribute--unit {
  font-size: 14px;
  line-height: 16px;
  color: var(--default--disabled--text-color--4);
  margin-left: @space-4;
}
